import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ScssService {

    // BehaviorSubjects publics pour permettre l'accès direct et la surveillance
    public warningColor$ = new BehaviorSubject<string>(this.getCSSVariable('--app-warning-color'));
    public warningContrastColor$= new BehaviorSubject<string>(this.getCSSVariable('--app-warning-color-contrast'));
    public errorColor$ = new BehaviorSubject<string>(this.getCSSVariable('--app-error-color'));
    public errorContrastColor$ = new BehaviorSubject<string>(this.getCSSVariable('--app-error-color-contrast'));
    public accentColor$ = new BehaviorSubject<string>(this.getCSSVariable('--app-accent-color'));
    public accentContrastColor$= new BehaviorSubject<string>(this.getCSSVariable('--app-accent-color-contrast'));



    constructor() {
        this.observeCSSChanges();
    }

    private getCSSVariable(name: string): string {
        return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    }

    private updateColorSubjects(): void {
        this.warningColor$.next(this.getCSSVariable('--app-warning-color'));
        this.warningContrastColor$.next(this.getCSSVariable('--app-warning-color-contrast'));
        this.errorColor$.next(this.getCSSVariable('--app-error-color'));
        this.errorContrastColor$.next(this.getCSSVariable('--app-error-color-contrast'));
    }

    // Méthode pour observer les changements des styles CSS
    private observeCSSChanges(): void {
        const observer = new MutationObserver(() => {
            this.updateColorSubjects();
        });

        // Surveille les changements sur l'élément <html> ou <body>
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['style'],
            subtree: true,
        });
    }
}